import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { setUserInfo, clearUserInfo } from "../store/headerSlice";

const AuthProvider = () => {
  const { accounts, inProgress } = useMsal();
  const dispatch = useDispatch();

  useEffect(() => {
    if (inProgress === "none") {
      if (accounts.length > 0) {
        const account = accounts[0];
				console.log(": AuthProvider -> account", account);
        const name = account.name;
        const email = account.username; 
        const token = account.idToken
        dispatch(setUserInfo({ name, email,token }));
      } else {
        dispatch(clearUserInfo());
      }
    }
  }, [accounts, inProgress, dispatch]);

  return null; 
};

export default AuthProvider;
